module.exports = __webpack_public_path__ + "assets/4563c0234a1d19c576e6154e78d038db.png";